import {
    NAVBAR_LINK_ABOUT_US,
    NAVBAR_LINK_CONTACT_US,
    NAVBAR_LINK_CREDIT_REPAIR,
    NAVBAR_LINK_HOME,
    NAVBAR_LINK_IMMIGRATION,
    NAVBAR_LINK_INSURANCE,
    NAVBAR_LINK_SERVICES,
    NAVBAR_LINK_SUPPORT,
    NAVBAR_LINK_TAXES,
    NAVBAR_LINK_TRAVEL,
    NAVBAR_CTA_BOOK_CONSULTATION,
    NAVBAR_CTA_CALL_NOW,
    NAVBAR_CTA_WHATSAPP,
    WHATSAPP_FAB_LABEL,
    WHATSAPP_FAB_TEASER_TITLE,
    WHATSAPP_FAB_TEASER_DESC,
    WHATSAPP_DIALOG_CLOSE,
    WHATSAPP_CHAT_AGENT_NAME,
    WHATSAPP_CHAT_STATUS,
    WHATSAPP_CHAT_GREETING,
    WHATSAPP_CHAT_PICK_TOPIC,
    WHATSAPP_CHAT_TOPIC_CREDIT,
    WHATSAPP_CHAT_TOPIC_IMMIGRATION,
    WHATSAPP_CHAT_TOPIC_TAXES,
    WHATSAPP_CHAT_TOPIC_INSURANCE,
    WHATSAPP_CHAT_TOPIC_TRAVEL,
    WHATSAPP_CHAT_TOPIC_NOTARY,
    WHATSAPP_CHAT_PLACEHOLDER,
    WHATSAPP_CHAT_SEND,
    WHATSAPP_CHAT_TYPING,
    WHATSAPP_CHAT_DEFAULT_BODY,
    WHATSAPP_CHAT_DISCLAIMER,
    NAVBAR_TAGLINE,
    NAVBAR_SERVICES_HEADING,
    NAVBAR_SERVICES_SUBHEADING,
    NAVBAR_SERVICE_DESC_CREDIT,
    NAVBAR_SERVICE_DESC_IMMIGRATION,
    NAVBAR_SERVICE_DESC_TAXES,
    NAVBAR_SERVICE_DESC_INSURANCE,
    NAVBAR_SERVICE_DESC_TRAVEL,
    NAVBAR_LINK_NOTARY,
    NAVBAR_SERVICE_DESC_NOTARY,
    COOKIE_CONSENT_MESSAGE,
    COOKIE_CONSENT_ACCEPT,
    COOKIE_CONSENT_DECLINE,
    COOKIE_CONSENT_LEARN_MORE,
} from "../types";


const enComponents = {
    navbar: {
        [NAVBAR_LINK_HOME]: "Home",
        [NAVBAR_LINK_IMMIGRATION]: "Immigration",
        [NAVBAR_LINK_CONTACT_US]: "Contact",
        [NAVBAR_LINK_ABOUT_US]: "About",
        [NAVBAR_LINK_SUPPORT]: "Support",
        [NAVBAR_LINK_SERVICES]: "Services",
        [NAVBAR_LINK_INSURANCE]: "Insurance",
        [NAVBAR_LINK_TAXES]: "Taxes",
        [NAVBAR_LINK_TRAVEL]: "Travel",
        // LEGAL: The service is branded "Credit Education & Coaching" — NEVER use "Credit Repair".
        // Using "Credit Repair" as a brand name triggers CROA liability under 15 U.S.C. §1679.
        [NAVBAR_LINK_CREDIT_REPAIR]: "Credit Education & Coaching",
        [NAVBAR_CTA_BOOK_CONSULTATION]: "Book Consultation",
        [NAVBAR_CTA_CALL_NOW]: "Call Now",
        [NAVBAR_CTA_WHATSAPP]: "WhatsApp",
        [NAVBAR_TAGLINE]: "Bilingual professionals serving your family since day one.",
        [NAVBAR_SERVICES_HEADING]: "Our Services",
        [NAVBAR_SERVICES_SUBHEADING]: "End-to-end solutions handled by bilingual experts.",
        [NAVBAR_SERVICE_DESC_CREDIT]: "Understand your credit reports, monitor your score, and build better financial habits with personalized coaching.",
        [NAVBAR_SERVICE_DESC_IMMIGRATION]: "Visas, residency and citizenship paperwork done right.",
        [NAVBAR_SERVICE_DESC_TAXES]: "Maximum refunds and year-round tax planning for individuals and small business.",
        [NAVBAR_SERVICE_DESC_INSURANCE]: "Health, life, ObamaCare, Medicare and dental plans — bilingual help.",
        [NAVBAR_SERVICE_DESC_TRAVEL]: "Flights, hotels and tours curated for stress-free trips.",
        [NAVBAR_LINK_NOTARY]: "Notary",
        [NAVBAR_SERVICE_DESC_NOTARY]: "Bilingual notary public for acknowledgments, jurats, vehicle titles and more.",
    },
    whatsapp: {
        [WHATSAPP_FAB_LABEL]: "Chat with us on WhatsApp",
        [WHATSAPP_FAB_TEASER_TITLE]: "Need help?",
        [WHATSAPP_FAB_TEASER_DESC]: "Chat with us \u00B7 we usually reply in minutes",
        [WHATSAPP_DIALOG_CLOSE]: "Close",
        [WHATSAPP_CHAT_AGENT_NAME]: "Linares Pro — Customer Care",
        [WHATSAPP_CHAT_STATUS]: "Online · Replies in minutes",
        [WHATSAPP_CHAT_GREETING]: "Hi there \ud83d\udc4b Welcome to Linares Pro Family Services. How can we help you today?",
        [WHATSAPP_CHAT_PICK_TOPIC]: "Pick a topic to get started:",
        // LEGAL: Must match the navbar label — "Credit Education & Coaching" only. See CROA note above.
        [WHATSAPP_CHAT_TOPIC_CREDIT]: "Credit Education & Coaching",
        [WHATSAPP_CHAT_TOPIC_IMMIGRATION]: "Immigration",
        [WHATSAPP_CHAT_TOPIC_TAXES]: "Taxes",
        [WHATSAPP_CHAT_TOPIC_INSURANCE]: "Insurance",
        [WHATSAPP_CHAT_TOPIC_TRAVEL]: "Travel",
        [WHATSAPP_CHAT_TOPIC_NOTARY]: "Notary",
        [WHATSAPP_CHAT_PLACEHOLDER]: "Type your message…",
        [WHATSAPP_CHAT_SEND]: "Send via WhatsApp",
        [WHATSAPP_CHAT_TYPING]: "typing…",
        [WHATSAPP_CHAT_DEFAULT_BODY]: "Hi! I'd like help with {{topic}}.",
        [WHATSAPP_CHAT_DISCLAIMER]: "This conversation continues on WhatsApp.",
    },
    cookieConsent: {
        [COOKIE_CONSENT_MESSAGE]: "We use cookies to improve your experience, analyze site traffic, and remember your language. By clicking Accept you agree to our use of cookies.",
        [COOKIE_CONSENT_ACCEPT]: "Accept",
        [COOKIE_CONSENT_DECLINE]: "Decline",
        [COOKIE_CONSENT_LEARN_MORE]: "Cookie policy",
    },
}


export default enComponents;


